module.exports = __webpack_public_path__ + "img/121.4e5ef7fd.jpg";